import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Overview from "./Overview";
import Game from "./Game";
import Stats from "./Stats";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Overview />
    },
    {
        path: "/games/:gameId",
        element: <Game />
    },
    {
        path: "/stats",
        element: <Stats />
    }
]);

const App = () => {
    return <RouterProvider router={router} />;
};

export default App;
